'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.moveElementToTrash = exports.createNewElement = undefined;

var _lodash = require('lodash');

var _elementActions = require('./elementActions');

var _elementMoveActions = require('./elementMoveActions');

var _selectionActions = require('./selection/selectionActions');

var _analytics = require('../analytics');

var _selectedElementsSelector = require('./selection/selectedElementsSelector');

var _elementHelper = require('../../common/elements/elementHelper');

var _undoRedoTransactionManager = require('../utils/undoRedo/undoRedoTransactionManager');

var _boardConstants = require('../../common/boards/boardConstants');

// Actions
var createNewElement = exports.createNewElement = function createNewElement(elementType, props) {
    return function (dispatch) {
        if (!props.isEditable) return;
        var transactionId = props.transactionId || (0, _undoRedoTransactionManager.getNewTransactionId)();

        dispatch((0, _elementActions.createAndSelectElement)({
            elementType: elementType,
            location: {
                parentId: props.currentBoardId,
                section: _boardConstants.BOARD_SECTIONS.INBOX,
                position: {
                    index: 0
                }
            },
            currentBoardId: props.currentBoardId,
            transactionId: transactionId
        }));
    };
};

// Constants


// Utils
// Lib
var moveElementToTrash = exports.moveElementToTrash = function moveElementToTrash(props) {
    return function (dispatch, getState) {
        if (!props.isEditable) return;

        var transactionId = (0, _undoRedoTransactionManager.getNewTransactionId)();

        var selectedElements = (0, _selectedElementsSelector.getSelectedElements)(getState());
        if (!selectedElements.size) return;

        dispatch((0, _selectionActions.deselectAllElements)({ transactionId: transactionId }));

        var location = {
            parentId: '' + props.currentBoardId + _boardConstants.BOARD_ID_TRASH_APPEND,
            section: _boardConstants.BOARD_SECTIONS.TRASH,
            position: {
                addedDate: new Date().getTime()
            }
        };

        var selectionToMoveToTrash = (0, _elementHelper.filterOutLinkedBoards)(selectedElements).filter((0, _lodash.negate)(_elementHelper.isElementLocked));

        (0, _analytics.analyticsEvent)('moved-element-to-trash-delete-key');

        var moves = selectionToMoveToTrash.map(function (element) {
            return { id: element.get('id'), location: location };
        }).toJS();
        dispatch((0, _elementMoveActions.moveMultipleElements)({ moves: moves, transactionId: transactionId }));
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/elementShortcutActions.js
// module id = 455
// module chunks = 0